import { formatMoney } from "./util.service"
import { get } from 'lodash'

export const getPersonToken = (data) => {
  const stripe = Stripe(process.env.VUE_APP_STRIPE_PUB_KEY)
  const payload = {
    person: data
  }

  return stripe.createToken('person', payload)
}

export const getAccountToken = (data) => {
  const stripe = Stripe(process.env.VUE_APP_STRIPE_PUB_KEY)
  const payload = {
    account: data,
  }

  return stripe.createToken('account', payload)
}

// personally identifiable information
export const getPiiToken = async (idNumber) => {
  const stripe = Stripe(process.env.VUE_APP_STRIPE_PUB_KEY)
  const payload = {
    personal_id_number: idNumber
  }

  const token = await stripe.createToken('pii', payload)
    .catch(e =>console.log('STRIPE ERROR',e ))

  return token
}

export const getBankAccountToken = async (data) => {
  const stripe = Stripe(process.env.VUE_APP_STRIPE_PUB_KEY)
  const payload = {
    bank_account: data
  }

  const result = await stripe.createToken('bank_account', payload)

  return result
}

export const getDefaultSourceFromCustomer = (customer) => {
  const { default_source, sources } = customer
  const { data } = sources

  return data.find(s => s.id === default_source)
}

export const readableCouponTerms = coupon => {
  const { duration, duration_in_months, percent_off, currency, amount_off} = coupon
  const period = duration === 'forever'
    ? 'forever'
    : duration_in_months ? `for ${duration_in_months} months` : ''

  const totalDiscount = percent_off
    ? `${percent_off}%`
    : formatMoney({ currency, amount: amount_off })

  return `${totalDiscount} off ${period}`
}

export const readablePlanTerms = (plan, quantity = 1) => {
  const moneyText = formatMoney({ amount: plan.amount * quantity, currency: plan.currency})
  return `${moneyText} / ${plan.interval_count} ${plan.interval}`
}

export const isInvoiceFromSubscription = (invoice) => {
  const { billing_reason } = invoice || {}

  return billing_reason === 'subscription'
    || billing_reason === 'subscription_cycle'
    || billing_reason === 'subscription_create'
    || billing_reason === 'subscription_update'
    || billing_reason === 'subscription_threshold'
    || billing_reason === 'upcoming'
}

export const readableSubscriptionTitle = (subscription) => {
  const { items = {} } = subscription || {}
  const { data = [] } = items

  // Todo convert to product
  if (data.length === 1) {
    return get(data, '[0].plan.nickname', '')
  } else if (data.length === 2) {
    return `${get(data, '[0].plan.nickname', '')} and ${get(data, '[1].plan.nickname', '')}`
  } else if (data.length === 3) {
    return `${get(data, '[0].plan.nickname', '')},
     ${get(data, '[1].plan.nickname', '')},
     and ${get(data, '[2].plan.nickname', '')}`
  } else {
    return `${get(data, '[0].plan.nickname', '')} and ${data.length - 1} more...`
  }
}

export const readableSubscriptionSubtitle = (subscription) => {

}

export const supportedWebhookEvents = {
  'customer.created': {

  },
  'customer.deleted': {},
  'customer.updated': {},
  'customer.discount.created': {},
  'customer.discount.deleted': {},
  'customer.discount.updated': {},
  'customer.source.created': {},
  'customer.source.deleted': {},
  'customer.source.expiring': {},
  'customer.source.updated': {},
  'customer.subscription.created': {},
  'customer.subscription.deleted': {},
  'customer.subscription.trial_will_end': {},
  'customer.subscription.updated': {},
  'invoice.created': {},
  'invoice.deleted': {},
  'invoice.finalized': {},
  'invoice.marked_uncollectible': {},
  'invoice.payment_action_required': {},
  'invoice.payment_failed': {},
  'invoice.payment_succeeded': {},
  'invoice.sent': {},
  'invoice.upcoming': {},
  'invoice.updated': {},
  'invoice.voided': {},
  'invoiceitem.created': {},
  'invoiceitem.deleted': {},
  'invoiceitem.updated': {},
  'payment_method.attached': {},
  'payment_method.card_automatically_updated': {},
  'payment_method.detached': {},
  'payment_method.updated': {},
  'payout.canceled': {},
  'payout.created': {},
  'payout.failed': {},
  'payout.paid': {},
  'payout.updated': {},
  'plan.created': {},
  'plan.deleted': {},
  'plan.updated': {},
  'product.created': {},
  'product.deleted': {},
  'product.updated': {},
}
